import { Validated } from 'it/primatoo/openapi/api/org/schemas/common/docs/_findallvalidateddocresponse/Validated';
import { BusinessProjectManagementService } from '@pt/api-client';
import { DialogType, DownloadResponse } from '@pt/pt-models';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WidgetDialogService } from '../documents/services/widget-dialog.service';
import { DialogService } from '../services/dialog.service';

export abstract class AbstractValidatedDocumentDetailPage {
  public validated: Array<Validated> = [];

  constructor(public service: BusinessProjectManagementService,
              public widgetDialogService: WidgetDialogService,
              public translateService: TranslateService,
              public dialogService: DialogService) {
  }

  loadValidated(docId: number) {
    if (docId) {
      this.service.getDocumentValidated(docId).subscribe(
        (success) => {
          this.validated = success.validatedList;
        }, () => {
          this.validated = [];
        }
      )
    }
  }

  // cancella
  // pdf ( se riesci viewer come in anteprima )
  // modifica ( titolo + descrizione )
  // dettagli ( POSTPONED)


  /**
   * Open PDF
   * @param docId
   * @param validated
   */
  openValidated(validated: Validated) {
    this.service.downloadValidated(validated.id, validated.name).subscribe(
      (response: DownloadResponse) => {
        const dialog = this.widgetDialogService.runPdfPreview(of(validated.name), response);
        dialog.subscribe();
      }
    );
  }

  deleteValidated(docId: number, validated: Validated) {
    const titleI18n = 'TITLE.TREATMENT_VALIDATED_DELETE';
    const messageI18n = 'MESSAGE.TREATMENT_VALIDATED_DELETE';
    this.dialogService.runConfirmDialog({
      title: this.translateService.stream(titleI18n),
      message: this.translateService.stream(messageI18n),
      dialogType: DialogType.MESSAGE,
      size: 'sm'
    }).subscribe((response) => {
      if (response) {
        this.service.deleteValidated(docId, validated.id).subscribe(
          () => {
            this.loadValidated(docId);
          }
        )
      }
    });
  }

  editValidated(docId: number, validated: Validated) {
    const title = this.translateService.stream('TITLE.EDIT_VALIDATED');
    this.dialogService.runEditDocumentValidated(title, docId, validated, this.service).subscribe((response) => {
      if (response) {
        this.loadValidated(docId);
      }
    });
  }

  detailsValidated(docId: number, validated: Validated) {

  }

  // d(validated: Validated) {
  //   this.actualValidated = validated;
  //   this.delete()
  // }
  // @Confirm({title: 'TITLE.TREATMENT_VALIDATED_DELETE', message: 'MESSAGE.TREATMENT_VALIDATED_DELETE', size: 'md'})
  // delete() {
  //   this.service.deleteValidated(this.docId, this.actualValidated.id).subscribe((success) => {
  //     this.reloadResult();
  //   })
  // }

  // edit() {
  //   alert('Edit not implemented');
  // }
  //
  // open() {
  //   alert('Open not implemented');
  // }
}
